import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { Observable } from 'rxjs';
import { deleteCallCostMutation } from '../queries/delete-call-cost.graphql';
import { DeleteProviderCallRateVariables } from '../queries/generated/DeleteProviderCallRate';

@Injectable({ providedIn: 'root' })
export class CallCostDetailApiService {
   constructor(private apiService: LcsApiService) {}

   // save(
   //    callCostDetail: CallCostDetailSaveModel,
   //    fields: (keyof ProviderCallRateInput)[]
   // ): Observable<ExecutionResult<SaveProviderCallRate>> {
   //    const callCost = createCallCostInput(callCostDetail, fields);

   //    const variables: SaveProviderCallRateVariables = {
   //       providerCallRate: callCost,
   //    };
   //    return this.apiService.query<SaveProviderCallRate, SaveProviderCallRateVariables>({
   //       query: SaveCallCostMutation,
   //       variables: variables,
   //    });
   // }

   deleteCallCost(providerCallRateId: number): Observable<ExecutionResult<void>> {
      return this.apiService.query<void, DeleteProviderCallRateVariables>({
         query: deleteCallCostMutation,
         variables: {
            providerCallRateId,
         },
      });
   }
}
